<template>
  <div class="container">
    <div class="cb_operate">
      <div class="cbo" @click.stop="preMonthClick">
        <span class="iconfont icon-arrow-lift"></span>
      </div>
      <div>{{ subtitle }}</div>
      <div class="cbo" @click.stop="nextMonthClick">
        <span class="iconfont icon-right"></span>
      </div>
    </div>

    <van-calendar
      type="single"
      color="#D62F2F"
      :poppable="false"
      :show-title="false"
      :show-subtitle="false"
      :show-mark="false"
      :show-confirm="false"
      :min-date="startDate"
      :max-date="endDate"
      :formatter="formatterInit"
      :default-date="nowDate"
      @confirm="onConfirm"
      class="calendar"
    >
    </van-calendar>

    <div class="activity-box">
      <div class="activity-title">活动安排</div>
      <div v-if="sameDayList.length > 0">
        <div
          v-for="(item, index) in sameDayList"
          :key="index"
          class="ab_item"
          @click="toSpecialDetail(item.SpecialId)"
        >
          <div>
            <div class="overFlowOne">{{ item.Name }}</div>
            <div>{{ item.StartDateDesc }} ~ {{ item.EndDateDesc }}</div>
          </div>
          <span class="iconfont icon-right"></span>
        </div>
      </div>
      <div class="noDataBox" v-else>
        <span class="iconfont icon-kong"></span>
        <div>今日暂无活动安排！</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Calendar } from "vant";
import { formatTimeDay } from "@/utils/date";
import { getShareData } from "@/utils/share";
import { liveSpecialListByTime } from "@/api/online";
var currentDate;
export default {
  name: "specialCalendar",
  components: {
    "van-calendar": Calendar,
  },
  data() {
    return {
      list: [], //当月活动数据
      sameDayList: [], //当日活动列表
      subtitle: "", //年月
      startDate: "",
      endDate: "",
      nowDate: new Date(),
    };
  },
  methods: {
    //格式化时间
    formatterInit(day) {
      return day;
    },

    //跳转专题详情
    toSpecialDetail(id) {
      this.$router.push({ path: "/specificActDetail", query: { sid: id } });
    },

    //处理月份（获取天数）
    dealDateGetDay(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dayNum = new Date(year, month, 0).getDate();
      this.subtitle = year + "年" + month + "月";
      this.startTime = [year, month, 1].join("/");
      this.endTime = [year, month, dayNum].join("/");
      this.startDate = new Date([year, month, 1].join("/"));
      this.endDate = new Date([year, month, dayNum].join("/"));
      this.getLiveSpecialListByTime(true);
    },

    //获取活动列表
    getLiveSpecialListByTime(first) {
      var that = this;
      var data = {
        StartDate: that.startTime,
        EndDate: that.endTime,
      };
      liveSpecialListByTime(data).then((res) => {
        that.list = res.Data.List;
        that.formatterInit = that.formatter;
        if (first) {
          that.onConfirm(currentDate);
        }
      });
    },

    // 日期选择
    onConfirm(event) {
      let time = formatTimeDay(event);
      var sameDayList = [];
      this.list.forEach((item, index) => {
        if (item.Date == time) {
          sameDayList = item.List;
          return false;
        }
      });
      this.sameDayList = sameDayList;
    },

    //格式化时间
    formatter(day) {
      const date = day.date.getDate();
      this.list.forEach((item, index) => {
        let arr = item.Date.split("-");
        if (arr[2] == date) {
          day.bottomInfo = [];
          day.className = "isActive";
          item.List.forEach((item2) => {
            day.bottomInfo.push(item2.Name);
          });
        }
      });
      return day;
    },

    //上个月点击
    preMonthClick() {
      currentDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
      this.dealDateGetDay(currentDate);
    },

    //下个月点击
    nextMonthClick: function () {
      currentDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
      this.dealDateGetDay(currentDate);
    },
  },
  created() {
    currentDate = new Date();
    this.dealDateGetDay(currentDate);
  },
  mounted() {
    getShareData(
      window.location.href,
      "直播活动上新啦，快来看看有没有感兴趣的内容吧"
    );
  },
};
</script>
<style lang="less" scoped>
.container {
  padding: 0 7px 50px 7px;
  .cb_operate {
    height: 47px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    color: #fff;
    background-color: #d62f2f;
    .cbo {
      padding: 0 17px;
      display: flex;
      align-items: center;
    }
    .iconfont {
      font-size: 14px;
    }
  }
  /deep/.van-calendar__bottom-info {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #666;
    padding-left: 9px;
    &::before {
      display: block;
      content: "";
      width: 6px;
      height: 6px;
      background: #d62f2f;
      border-radius: 50%;
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 0px;
      transform: translate(0, -50%);
    }
  }
  /deep/.van-calendar__header {
    background: #eeeeee;
    box-shadow: 0px 0px 0px rgba(233, 233, 233, 1);
  }
  /deep/.van-calendar__weekday {
    color: #666666;
  }
  /deep/.van-calendar__month-title {
    display: none;
  }
  /deep/.van-calendar__month {
    padding-bottom: 17px;
  }
  /deep/.van-calendar__selected-day {
    position: relative;
    border-radius: 50% !important;
  }
  /deep/.isActive {
    .van-calendar__selected-day {
      &::before {
        position: absolute;
        content: "";
        bottom: 8px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #fff;
      }
      .van-calendar__bottom-info {
        display: none;
      }
    }
  }
  .activity-box {
    margin-top: 5px;
    padding-top: 20px;
    color: #333;
    font-size: 13px;
    border-top: 1px solid #eeeeee;
    .activity-title {
      font-size: 18px;
      margin-bottom: 10px;
    }
    .ab_item {
      height: 61px;
      border-bottom: 1px solid #e4e4e4;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px 0 22px;
      position: relative;
      &::before {
        display: block;
        content: "";
        position: absolute;
        z-index: 2;
        top: 16px;
        left: 5px;
        width: 8px;
        height: 8px;
        background: #d62f2f;
        border-radius: 50%;
      }
      .iconfont {
        font-size: 10px;
        color: #999999;
      }
    }
  }
}
</style>

